
import Vue from 'vue'
import router from '@/router'
import Element from 'element-ui'
import axios from "axios"
import 'element-ui/lib/theme-chalk/index.css'

// axios.interceptors.request.use(function (config) {

//       config.headers.token = "42aa091d-050b-48f3-986c-52ff4e1f5523";    //将token放到请求头发送给服务器
//       return config;

// })
axios.defaults.withCredentials = true; // 允许携带cookie
// // 定义一个请求拦截器
// axios.interceptors.request.use(function (config) {
//   if (localStorage.token) {  // 判断是否存在token，如果存在的话，则每个http header都加上token
//     config.headers["x-user-token"] = `${localStorage.token}`;
//   } else {
//     router.push({
//       name: "Login" //跳转到登录页面
//     });
//   }
//   return config;
// },
//   err => {
//     return Promise.reject(err);
//   })

// //定义一个响应拦截器
// axios.interceptors.response.use(function (res) {
//   if (res.data.code === 500) {
//     Vue.prototype.$message({
//       type: 'error',
//       showClose: true,
//       message: res.data.message
//     })
//   } else if (res.data.code === 403) {
//     Vue.prototype.$message({
//       type: 'warning',
//       showClose: true,
//       message: res.data.message
//     })
//     router.push({
//       name: "Login" //跳转到登录页面
//     });
//   } else {
//     return res
//   }

// })
// var get = function (method, url, obj) {
//   return new Promise((resolve, reject) => {
//     axios({
//       method: method,
//       url: url,
//       data: obj
//     }).then(response => {
//         resolve(response)
//     }).catch(error => {
//       console.log(error)
//       reject("服务器不在线");
//     });
//   })
// }


var getAxios = function (method, url, obj) {
  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: url,
      data:obj,
      headers: {'x-requested-with': 'XMLHttpRequest'}
    }).then(response => {
    //   if(response.data.status===200||response.data.status===1000){
        resolve(response)
    //   }else{
    //     Vue.prototype.$message({
    //       type: "error",
    //       showClose: true,
    //       message: response.data.msg
    //     });
    //   }
    }).catch(error => {
      console.log(error)
      reject("服务器不在线");
    });
  })
}
export default getAxios